import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'whitespace' })
export class WhiteSpacePipe implements PipeTransform {
  transform(value: string | undefined) {
    return value ? value.replace(/([A-Z])/g, ' $1') : '';
  }
}
